import { render, staticRenderFns } from "./UploadTitle.vue?vue&type=template&id=99bcc2ca"
import script from "./UploadTitle.vue?vue&type=script&lang=js"
export * from "./UploadTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports